export default "__VITE_ASSET__B92FERzG__"